import React from 'react';
import PropTypes from 'prop-types';
import {Link as RouterLink} from 'react-router-dom';
import {Container, Img, InfoContainer, SmallTitleWhite, BigTitle} from './styles';

const InformationTile = ({imageUrl, bigTitle, smallTitle, link}) => (
  <Container {...(link.startsWith('/') ? {as: RouterLink, to: link} : {href: link, target: '_blank'})}>
    <Img src={imageUrl} />
    <InfoContainer>
      <BigTitle>{bigTitle}</BigTitle>
      <SmallTitleWhite>{smallTitle}</SmallTitleWhite>
    </InfoContainer>
  </Container>
);

InformationTile.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  bigTitle: PropTypes.string.isRequired,
  smallTitle: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default InformationTile;
